export enum YieldType {
  Text,
  Number,
  Percentage,
  Date,
  Image,
  Icon,
  Currency,
  ProgressBar,
  Download,
  Color,
  Check,
  FileIcon,
  AnalogProgressBar
}
